/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import {
  IntegrationRuntimeNodesGetOptionalParams,
  IntegrationRuntimeNodesGetResponse,
  IntegrationRuntimeNodesDeleteOptionalParams,
  UpdateIntegrationRuntimeNodeRequest,
  IntegrationRuntimeNodesUpdateOptionalParams,
  IntegrationRuntimeNodesUpdateResponse,
  IntegrationRuntimeNodesGetIpAddressOptionalParams,
  IntegrationRuntimeNodesGetIpAddressResponse,
} from "../models/index.js";

/** Interface representing a IntegrationRuntimeNodes. */
export interface IntegrationRuntimeNodes {
  /**
   * Gets a self-hosted integration runtime node.
   * @param resourceGroupName The resource group name.
   * @param factoryName The factory name.
   * @param integrationRuntimeName The integration runtime name.
   * @param nodeName The integration runtime node name.
   * @param options The options parameters.
   */
  get(
    resourceGroupName: string,
    factoryName: string,
    integrationRuntimeName: string,
    nodeName: string,
    options?: IntegrationRuntimeNodesGetOptionalParams,
  ): Promise<IntegrationRuntimeNodesGetResponse>;
  /**
   * Deletes a self-hosted integration runtime node.
   * @param resourceGroupName The resource group name.
   * @param factoryName The factory name.
   * @param integrationRuntimeName The integration runtime name.
   * @param nodeName The integration runtime node name.
   * @param options The options parameters.
   */
  delete(
    resourceGroupName: string,
    factoryName: string,
    integrationRuntimeName: string,
    nodeName: string,
    options?: IntegrationRuntimeNodesDeleteOptionalParams,
  ): Promise<void>;
  /**
   * Updates a self-hosted integration runtime node.
   * @param resourceGroupName The resource group name.
   * @param factoryName The factory name.
   * @param integrationRuntimeName The integration runtime name.
   * @param nodeName The integration runtime node name.
   * @param updateIntegrationRuntimeNodeRequest The parameters for updating an integration runtime node.
   * @param options The options parameters.
   */
  update(
    resourceGroupName: string,
    factoryName: string,
    integrationRuntimeName: string,
    nodeName: string,
    updateIntegrationRuntimeNodeRequest: UpdateIntegrationRuntimeNodeRequest,
    options?: IntegrationRuntimeNodesUpdateOptionalParams,
  ): Promise<IntegrationRuntimeNodesUpdateResponse>;
  /**
   * Get the IP address of self-hosted integration runtime node.
   * @param resourceGroupName The resource group name.
   * @param factoryName The factory name.
   * @param integrationRuntimeName The integration runtime name.
   * @param nodeName The integration runtime node name.
   * @param options The options parameters.
   */
  getIpAddress(
    resourceGroupName: string,
    factoryName: string,
    integrationRuntimeName: string,
    nodeName: string,
    options?: IntegrationRuntimeNodesGetIpAddressOptionalParams,
  ): Promise<IntegrationRuntimeNodesGetIpAddressResponse>;
}
